module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/39d8f257133d2c33c43a9d74d71d6c13.png";